import { parseURI as parseWSURI } from '@cian/chats-api/lib/browser/websocket/uri';
import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { createContext } from './createContext';
import { prepareClientState } from './prepareClientState';
import { openEventChannel } from '../../../shared/actions/socket';
import { AppContainer } from '../../../shared/containers/App';
import { attachReducers } from '../../../shared/reducers/attachReducers';
import { createAppStore } from '../../../shared/store/createAppStore';
import { TSerializableAppState } from '../../../shared/types/appState';
import { TReduxActions } from '../../../shared/types/redux/actions';
import { EventChannel } from '../../../shared/types/socket';

export function runApp() {
  const context = createContext();
  const { config, logger } = context;

  const state = config.getStrict<TSerializableAppState>('initialState');
  const dispatchActions = config.get<TReduxActions[]>('dispatchActions');

  const chatsBaseWsApi = config.getStrict<string>('chats.webSocketUrl');

  const baseWSUri = parseWSURI(chatsBaseWsApi);

  if (!baseWSUri) {
    logger.error('Incorrect WS URI', { chatsBaseWsApi });
    throw new Error('Incorrect WS URI');
  }

  const eventChannel = new EventChannel({
    baseWSUri,
  });

  const store = createAppStore({
    eventChannel,
    initialState: prepareClientState(state),
    optionalParams: {
      dispatchReducerAddedAction: true,
      dispatchRunnerSagaAction: true,
    },
    context,
  });

  attachReducers(store);

  const rootElement = document.getElementById('frontend-chats');

  if (!rootElement) {
    throw new Error('Unable to find element #frontend-chats');
  }

  // TODO: выпилить
  if (state.session.token) {
    store.dispatch<any>(openEventChannel());
  }

  if (dispatchActions && dispatchActions.length) {
    dispatchActions.forEach(action => store.dispatch(action));
  }

  hydrateRoot(rootElement, <AppContainer store={store} context={context} />);
}
